import React from 'react';

const UpdateDate = (props) => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M12 7.90588V12.4059" stroke="#3F3C43" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M15.9 14.6559L12 12.4059"
        stroke="#3F3C43"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M17.2687 9.75275H21.0187V6.00275"
        stroke="#3F3C43"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M17.8312 18.2371C16.6777 19.3916 15.2077 20.178 13.6072 20.4969C12.0067 20.8157 10.3475 20.6528 8.83966 20.0285C7.33177 19.4043 6.0429 18.3469 5.13608 16.99C4.22926 15.6332 3.74524 14.0379 3.74524 12.4059C3.74524 10.7739 4.22926 9.17858 5.13608 7.82173C6.0429 6.46488 7.33177 5.40746 8.83966 4.78324C10.3475 4.15901 12.0067 3.99603 13.6072 4.3149C15.2077 4.63378 16.6777 5.42018 17.8312 6.57464L21.0187 9.75276"
        stroke="#3F3C43"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};

export default UpdateDate;
